/**
 * Core: Get Collection
 * ------------------------------------------------------------------------------
 * - Queries the Storefront API and returns a formatted collection object.
 */
import collectionQuery from '~/graphql/collection.gql'

import { formatCollection } from '~/format/collection'

/**
 * Return a formatted Shopify Collection object.
 * - Query Storefront API for a given handle
 * - Format each product response object
 * - https://shopify.dev/docs/api/storefront/2023-07/queries/collection
 * @param {data} data - Parameters.
 * @param {String} [startCursor] - Start point in product listing. Loads the 1st
 *   page if `null`. See: https://shopify.dev/docs/api/usage/pagination-graphql
 * @param {String} handle - Handle of the given Collection.
 * @param {String?Number} first - How many products to load.
 * @returns
 */
export async function getCollection({ startCursor = null, handle, first = 4 }) {
  try {
    const storefrontResponse = await mint.Query({
      query: collectionQuery,
      variables: {
        country: mint.shop.country,
        handle: handle,
        first,
        language: mint.shop.language,
        after: startCursor,
      },
    })

    return formatCollection(storefrontResponse)
  } catch (error) {
    mint.Log('warning', 'Could not fetch Collection', error, {
      handle,
    })

    return error
  }
}